// extracted by mini-css-extract-plugin
export default {"loginResponsibly":"loginResponsibly-T5krk"};